import { render, staticRenderFns } from "./ClearFilters.vue?vue&type=template&id=49aee2cc&lang=pug&"
import script from "./ClearFilters.vue?vue&type=script&lang=js&"
export * from "./ClearFilters.vue?vue&type=script&lang=js&"
import style0 from "./ClearFilters.vue?vue&type=style&index=0&id=49aee2cc&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cms/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49aee2cc')) {
      api.createRecord('49aee2cc', component.options)
    } else {
      api.reload('49aee2cc', component.options)
    }
    module.hot.accept("./ClearFilters.vue?vue&type=template&id=49aee2cc&lang=pug&", function () {
      api.rerender('49aee2cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/interface/header/ClearFilters.vue"
export default component.exports